var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnchorOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.4205L12.2273 6.64775C12.3327 6.75324 12.4758 6.8125 12.625 6.8125C12.7742 6.8125 12.9173 6.75324 13.0227 6.64775C13.1282 6.54226 13.1875 6.39918 13.1875 6.25C13.1875 6.10082 13.1282 5.95774 13.0227 5.85225L7.39775 0.227252C7.29226 0.121763 7.14918 0.0625 7 0.0625C6.85082 0.0625 6.70774 0.121763 6.60225 0.227252L0.977463 5.85204L0.977252 5.85225C0.871763 5.95774 0.8125 6.10082 0.8125 6.25C0.8125 6.39918 0.871763 6.54226 0.977252 6.64775C1.08274 6.75324 1.22582 6.8125 1.375 6.8125C1.52418 6.8125 1.66726 6.75324 1.77275 6.64775L1.77296 6.64754L7 1.4205Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorOpen);
export default __webpack_public_path__ + "static/media/anchorOpen.9d2b8ba2c05f151c7aa9532e5a45973e.svg";
export { ForwardRef as ReactComponent };